const setupTabs = () => {
  const tabs = document.querySelectorAll('.tabs.country-selector li[role="tab"]');

  tabs.forEach(tab => {
    const panelId = tab.getAttribute("aria-controls");
    const panel = document.getElementById(panelId);

    if (panel) {
      const label = tab.textContent.trim();
      const container = panel.querySelector(".container");

      if (container) {
        const button = document.createElement("button");
        button.className = "tabpanel-button";
        button.setAttribute("aria-controls", panelId);
        button.textContent = label;

        panel.insertBefore(button, container);

        button.addEventListener("click", e => {
          e.stopPropagation();

          if (panel.classList.contains("cmp-tabs__tabpanel--active")) {
            panel.classList.remove("cmp-tabs__tabpanel--active");
          } else {
            document.querySelectorAll(".cmp-tabs__tabpanel")
              .forEach(p => p.classList.remove("cmp-tabs__tabpanel--active"));

            panel.classList.add("cmp-tabs__tabpanel--active");
          }
        });

        panel.addEventListener("click", e => {
          if (!e.target.classList.contains("tabpanel-button")) {
            panel.classList.remove("cmp-tabs__tabpanel--active");
          }
        });
      }
    }
  });
};

const onDocumentReady = () => {
  const tabsRoot = document.querySelector('.tabs.country-selector');
  if (tabsRoot) {
    setupTabs();
  }
};

if (document.readyState !== "loading") {
  onDocumentReady();
} else {
  document.addEventListener("DOMContentLoaded", onDocumentReady);
}
